import { render, staticRenderFns } from "./FoldersManagement.vue?vue&type=template&id=e78940cc&scoped=true&"
import script from "./FoldersManagement.vue?vue&type=script&lang=ts&"
export * from "./FoldersManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78940cc",
  null
  
)

export default component.exports